var map = {
	"./antecsalarial/logo.svg": "2962",
	"./brsurgery/logo.svg": "a491",
	"./diserv_ep/logo.svg": "bc0f",
	"./featbankltda/logo.svg": "c04e5",
	"./finanfastreneg/logo.svg": "181a",
	"./ideal_creditosimples/logo.svg": "a1a0",
	"./iriom/logo.svg": "40da",
	"./master3ep/logo.svg": "ff86",
	"./mrm/logo.svg": "424f",
	"./nellpay/logo.svg": "7dae",
	"./precatorios/logo.svg": "1554",
	"./tradicash/logo.svg": "1f12",
	"./work8/logo.svg": "6182"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31d9";